export function getNamespace() {
    return 'mai';
}
export function getComponentName(name) {
    return ''.concat(getNamespace()).concat(name);
}
